module.exports = __webpack_public_path__ + "icons/soundcloud-thumb-aaae12105e59e9a3b6993b53871a78ff.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/soundcloud-thumb.svg
// module id = Yan+
// module chunks = 20